<template>
  <!-- 头部整体盒子 -->
  <div id="header" >
    <!-- 头部顶部 -->
<!--    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>-->
    <!-- 电脑导航 -->
    <div class="kfBar clearfix" >
      <ul class="app_hover">
        <li class='person'>
          <a href="javascript:;"
             @click="myjy()"
          >
            Consult
          </a>
        </li>
        <el-popover
          placement="left"
          width="auto"
          trigger="hover"

        >
          <!-- 二维码图片，这里假设使用一个占位图片，你可以替换为实际的二维码图片地址 -->
          <img src="./../assets/image/ewm.png" width="180" height="180" alt="">
          <!-- 定义触发 popover 的按钮 -->
          <template #reference>
            <li class='app'>
            </li>
          </template>
        </el-popover>
      </ul>
    </div>
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/image/logo2.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <router-link to="/homeENG" tag="li">
            <div>
              <img src="@/assets/image/home.png">
            </div>
            <p>HOME</p>
        </router-link>
        <router-link to="/productserveENG" tag="li">
          <div>
            <img src="@/assets/image/produce.png">
          </div>
          <p>Product Center</p>
        </router-link>
        <router-link to="/studycenterENG" tag="li">
          <div>
            <img src="@/assets/image/study.png">
          </div>
          <p>R&D Center</p>
        </router-link>
        <router-link to="/QuotationENG" tag="li">
          <div>
            <img src="@/assets/image/Quotation.png">
          </div>
          <p>Quotation</p>
        </router-link>
        <router-link to="/contactusENG" tag="li">
          <div>
            <img src="@/assets/image/contact.png">
          </div>
          <p>Contact Us</p>
        </router-link>
<!--        <div class="language">
          <img class="languages" src="@/assets/image/language.png" />
          <img class="more" src="@/assets/image/down.png" />
        </div>-->
<!--        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>-->
      </ul>
 <div class="lange"  >

        <div id="google_translate_element" style="position:absolute;top:-30px;right:90px;z-index:2000;opacity:0.7"></div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">

      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div class="header-nav-m-logo">
          <img  class="center-block" src="@/assets/image/STlogo.png"  alt="logo">
        </div>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Headereng",
  data() {
    return {
      goRoute:'',
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "HOME",
          path: "/homeENG",
          children: []
        },
        {
          name: "Product Center",
          path: "/productserveENG",

        },
        {
          name: "R&D Center",
          path: "/studycenterENG",
          children: []
        },
        {
          name: "Quotation",
          path: "/QuotationENG",
        },
        {
          name: "Contact Us",
          path: "/contactusENG",
          children: []
        },
        /*{
          name: "中文",
          path: "/",
          children: []
        },*/
      ]
    };
  },
  methods: {
    routerTo(){
      var routeName=this.$route.path
      var reg=new RegExp('ENG','g')
      this.goRoute=routeName.replace(reg,'')
      this.$router.push(this.goRoute)

    },
    myjy(){
      window.open('https://www4c1.53kf.com/webCompany.php?kf_sign=Tk1NjMTczOAwMzEzNzU2OTUyNTkwMDAxNjM2NjY2NTU=&arg=9005228&style=1&guest_id=13098332848001&language=en&charset=gbk&referer=http%3A%2F%2F172.16.3.116%3A8888%2F&keyword=&tpl=crystal_blue&uid=5e62a8acf82a158a08b3cdb3bc4ebcca&is_group=&tfrom=1', '_blank', 'height=600,width=800,top=50,left=200,status=yes,toolbar=no,menubar=no,resizable=no,scrollbars=no,location=no,titlebar=no')
      //window.open("', '_blank', 'height=600,width=800,top=240,left=560,status=yes,toolbar=no,menubar=no,resizable=no,scrollbars=no,location=no,titlebar=no")
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  font-family: 微软雅黑;
  background: rgba(22,38,62,0.7);
  /*transition: all ease 0.6s;*/
  width: 100%;
  position: fixed;
  z-index: 999;
}
#header .header-top {
  height: 80px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 80px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 190px;
  height: 42px;
  float: left;
  position: relative;
  margin-top: 18px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  height: 100%;

}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  color: white;
  /*line-height: 110px;*/
  float: right;
  margin: 0;
  max-width: 900px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  height: 80px;
  float: left;
  margin: 0 15px;
  line-height: 80px;
  position: relative;
  display: flex;
  cursor: pointer;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/*#header .header-nav .header-nav-wrapper > li:hover p {
  color: #2D7DD9;
}*/
/*导航栏样式*/
#header .header-nav .header-nav-wrapper > li > div {
  width: 30px;
  height: 30px;
  background: white;
  margin-top: 25px;
  margin-right: 10px;
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  vertical-align: bottom;
}
#header .header-nav .header-nav-wrapper > li > div > img {
  width: 15px;
  height: 15px;
  margin: 7px auto;
}
#header .lange{
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 30px;
  display: flex;
  color: white;
}
#header .lange > div{
  width: 14px;
  height: 14px;
  margin-top: 3px;
  margin-right: 5px;
}
#header .lange > div img{
  width: 100%
}
#header .header-nav .language {
  margin-top: 33px;
  float: right;
  display: flex;
  width: 40px;
}
#header .header-nav .language .more{
  width: 11px;
  height: 7px;
  margin-top: 3px;
  margin-left: 3px;
}
#header .header-nav .language .languages{
  width: 15px;
  height: 15px;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
    background: #014594;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-menu img {
    width: 190px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  #header .header-nav .header-nav-wrapper > li {
    height: 80px;
    float: left;
    margin: 0 5px;
    line-height: 80px;
    position: relative;
    display: flex;
    cursor: pointer;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 80px;
    font-size: 20px;
    line-height: 50px;
    background: #014594;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background: #666;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #999;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
.kfBar {
  position: fixed;
  right: 0px;
  top: 270px;
  width: 60px;
  height: 30px;
  z-index: 9999;
}
.kfBar ul {
    float: right;
    line-height: 30px;
}
.kfBar ul li {
    height: 70px;
    width: 60px;
    background: #1F8CEB;
    margin-bottom: 10px;
}
.kfBar ul li.person {
  height: 80px;
  background: url("./../assets/image/kf.png") #1F8CEB no-repeat;
  background-position: 10px 10px;
  background-size: 70%;
}
.kfBar ul li.person a{
  display: block;
  text-align: center;
  color: #fff;
  padding-top: 55px;
  font-size: 12px;
  line-height: 15px;
}
.kfBar ul li.app {
  height: 70px;
  background: url("./../assets/image/app.png") #1AB906 no-repeat;
  background-size: 70px auto;
  background-position: -5px;
}
.kfBar ul li.app button{
  display: block;
  line-height: 15px;
  width: 60px;
  height: 70px;
  background: none;
  border: none;
}
.kfBar ul li.app button:hover{
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderENG.vue